<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <v-text-field
            label="Busca"
            v-model="filter"
            outlined
            dense
            hide-details
            append-icon="eva-search-outline"
            clearable
            background-color="white"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="light-blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click:outside="close"
              >
                Nova apresentação
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Nova apresentação</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="presentation.name"
                        label="Nome"
                        :hide-details="!errors.presentation"
                        :error-messages="errors.presentation"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row
        v-for="presentation in filteredMedicinePresentations"
        :key="presentation.id"
      >
        <v-col>
          <PresentationListItem
            :presentation="presentation"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import PresentationListItem from "@/components/config/medicine/presentation/item/index.vue";

export default {
  name: "PresentationList",
  components: {
    PresentationListItem,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      presentation: {},
      filter: "",
    };
  },
  apollo: {
    medicinePresentations: {
      query: require("@/graphql/medicine/medicine_presentations.gql"),
      update(data) {
        return data.medicinePresentations
      },
    },
  },
  computed: {
    filteredMedicinePresentations() {
      let medicinePresentations = this.lodash.orderBy(
        this.medicinePresentations,
        (e) => {
          return e.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        },
        ["asc"]
      );

      if (this.filter) {
        medicinePresentations = this.lodash.filter(
          medicinePresentations,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return medicinePresentations;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.presentation = {};
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/medicine/save_presentation.gql"),
        variables: {
          presentationId: "",
          name: this.presentation.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.medicinePresentations.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let name = this.presentation.name;
      if (this.lodash.isEmpty(name?.trim())) {
        this.errors.presentation = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
